(function () {

    var resizeTimer = null;
    var carouselClass = ".carousel";

    function initCarousel() {
        var carouselClass = ".carousel";

        $(carouselClass).each(function () {
            var $carousel = $(this);
            var slidesToShow = $carousel.data("slides-to-show") || 3;
            var infinite = $carousel.data("infinite");
            var carouselMobile = $carousel.data("carousel-mobile");

            if($carousel.hasClass("slick-initialized")) {
                return;
            }

            if (carouselMobile) {
                if (window.innerWidth < 840) {
                    $carousel.slick({
                        mobileFirst: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: true,
                        arrows: true,
                        dots: true,
                        infinite: infinite,
                        responsive: [{
                            breakpoint: 992,
                            settings: "unslick"
                        }]
                    });
                }
            }

            if (!carouselMobile) {
                $carousel.slick({
                    slidesToShow: slidesToShow,
                    slidesToScroll: slidesToShow,
                    adaptiveHeight: false,
                    arrows: true,
                    dots: true,
                    infinite: infinite,
                    responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            adaptiveHeight: true,
                        }
                    }]
                });
            }

            $carousel.on("afterChange", function () {
                var headerHeight = $(".header").outerHeight();
                var scrollPos = $(window).scrollTop();
                var pos = $carousel.offset().top - (headerHeight + 20);

                if (window.innerWidth < 840 && scrollPos > pos) {
                    $("html, body").animate({
                        scrollTop: pos
                    }, 300);
                }
            });
        });
    }

    initCarousel();

    $(window).on('resize', function () {
        initCarousel();
    });
})();